import React from "react";
import { Facebook, Twitter, Linkedin, PawPrint } from "lucide-react";
import Reveal from "../Reveal";
import AppointmentBanner from "../AppointmentBanner";

const defaultTeam = [
  { role: "Owner", name: "Kirstie", img: "staff_kirstie.png", pos: "16% 28%" },
  { role: "Manager", name: "Jake", img: "staff_jake.png", pos: "50% 20%" },
  { role: "Clinical Director & Veterinary Surgeon", name: "Nadia", img: "staff_nadia.png", pos: "70% 25%" },
  { role: "Registered Veterinary Nurse (RVN)", name: "Rebecca", img: "staff_rebecca.png", pos: "35% 30%" },
  { role: "Veterinary Care Assistant", name: "Stephanie", img: "staff_stephanie.png", pos: "45% 20%" },
];

const Team = ({ members = defaultTeam, showBanner = true, eyebrow = "Meet Our Team" }) => {
  return (
    <section className="mx-auto max-w-[1290px] px-5 py-20 md:py-28">
      <div className="mx-auto max-w-2xl text-center">
        <Reveal animation="rubberBand">
          <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
            <PawPrint className="h-5 w-5" />
            {eyebrow}
          </span>
        </Reveal>
        <Reveal animation="fadeInUp" delay={100}>
          <h2 className="mt-4 font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
            Dedicated Professionals Committed to Your Pet's Wellness
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {members.map((m, i) => (
          <Reveal key={m.name} animation="fadeInUp" delay={i * 100} className="group">
            <div className="relative overflow-hidden rounded-[28px]">
              <img
                src={`/pawelle/${m.img}`}
                alt={`${m.name} – ${m.role}`}
                style={{ objectPosition: m.pos || "center" }}
                className="aspect-[3/3.6] w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-x-0 bottom-0 flex translate-y-3 items-center justify-center gap-2 p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                {[Facebook, Twitter, Linkedin].map((Icon, k) => (
                  <a key={k} href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-pawelle-primary transition hover:bg-pawelle-primary hover:text-white" aria-label="social">
                    <Icon className="h-4 w-4" />
                  </a>
                ))}
              </div>
            </div>
            <p className="mt-4 font-body text-[13px] font-bold uppercase tracking-wide text-pawelle-primary">{m.role}</p>
            <h4 className="mt-1 font-display text-[20px] font-semibold text-pawelle-ink">{m.name}</h4>
          </Reveal>
        ))}
      </div>

      {showBanner && <AppointmentBanner className="mt-16" />}
    </section>
  );
};

export default Team;
